import { toast } from 'sonner';

import { useTaxonomyContext } from '../context/TaxonomyContext';

import { Button } from '@/components/ui/Button';
import { DialogHeader, DialogFooter } from '@/components/ui/Dialog';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/Dialog';
import { TaxonomyGetResponse } from '@/services/TaxonomiesService';

interface RemoveTaxonomyModalProps {
  itemSelected: TaxonomyGetResponse;
  isOpen: boolean;
  onClose: () => void;
}

export function RemoveTaxonomyProperty({
  itemSelected,
  isOpen,
  onClose,
}: RemoveTaxonomyModalProps) {
  const { setTaxonomiesUpdated } = useTaxonomyContext();
  function confirmRemove() {
    if (itemSelected.id) {
      setTaxonomiesUpdated((prev) => ({
        ...prev,
        taxonomiesToRemove: [...prev.taxonomiesToRemove, itemSelected.id ?? ''],
      }));
      toast.success('Taxonomy property deleted, save changes at the end.');
      onClose();
    }
    setTaxonomiesUpdated((prev) => ({
      ...prev,
      data: prev.data.filter(
        (item) =>
          item.property !== itemSelected.property ||
          item.categoryName !== itemSelected.categoryName ||
          item.groupName !== itemSelected.groupName,
      ),
    }));
    toast.success('Taxonomy property deleted, save changes at the end.');
    onClose();
  }
  function handleCancel() {
    onClose();
  }
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Confirm Deletion</DialogTitle>

          <DialogDescription>
            Are you sure you want to delete the taxonomy property &quot;
            {itemSelected.property}&quot;? This action cannot be undone.
          </DialogDescription>
        </DialogHeader>

        <DialogFooter>
          <Button variant="outline" onClick={handleCancel}>
            Cancel
          </Button>

          <Button variant="destructive" onClick={confirmRemove}>
            Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
